import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import { useSearchParams } from "react-router-dom";
import MultiSelectionDropdown from "../App/MultiSelectionDropdown";

function CampaignData() {
  const [isAnimation, setIsAnimation] = useState(false);

  const [FilterObjectObject, setFilterObjectObject] = useState<any>({
    StartDate: new Date(),
    EndDate: new Date(),
    DiscountCode: "",
    IPAddress: "",
    Status: 0,
  });
  const [StatusStatus, setStatusStatus] = useState<any>([]);
  const [CampaignFilterList, setCampaignFilterList] = useState<any>([]);
  const [Totals, setTotals] = useState<any>({});

  const [selectedPIDs, setselectedPIDs] = useState("");

  useEffect(() => {
    GetInitialFiltersData();
    GetCampaignFilterList();
  }, []);

  useEffect(() => {
    if (StatusStatus && StatusStatus.length > 0) ClearFilter(1);
  }, [StatusStatus]);

  function GetInitialFiltersData() {
    let object = {} as any;
    object.Days = -10;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/SiteUser/GetStartAndEndDataAndListsDataForCamControl",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          setStatusStatus(l_oResponse);

          // console.log(l_oResponse);
        }
        // setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function LoadDataMonth(Type: any) {
    if (Type == 100) {
      FilterObjectObject.StartDate = StatusStatus[0].StartDataLast2;
      FilterObjectObject.EndDate = StatusStatus[0].EndDataLast2;
    } else if (Type == 1) {
      FilterObjectObject.StartDate = StatusStatus[0].StartData;
      FilterObjectObject.EndDate = StatusStatus[0].EndData;
    } else {
      FilterObjectObject.StartDate = StatusStatus[0].StartDataLast;
      FilterObjectObject.EndDate = StatusStatus[0].EndDataLast;
    }

    LoadCampaignData();
  }
  function ClearFilter(IsFirst: any) {
    FilterObjectObject.Status = -1;
    FilterObjectObject.StartDate = StatusStatus[0].StartData;
    FilterObjectObject.EndDate = StatusStatus[0].EndData;
    FilterObjectObject.Status = -1;
    FilterObjectObject.CampaignCode = "";
    FilterObjectObject.DiscountCode = "";
    FilterObjectObject.IPAddress = "";

    LoadCampaignData();
  }

  function LoadCampaignData() {
    setIsAnimation(true);
    let object = {} as any;
    object.StartDate = FilterObjectObject.StartDate;
    object.EndDate = FilterObjectObject.EndDate;
    object.Status = FilterObjectObject.Status;
    object.CampaignCode = FilterObjectObject.CampaignCode;
    object.DiscountCode = FilterObjectObject.DiscountCode;
    object.IPAddress = FilterObjectObject.IPAddress;
    axiosAuth
      .post(AppContext.APIURL + "api/PTCampaign/LoadCampaignDataAdmin", object)
      .then((response: any) => {
        if (response.status === 200) {
          let l_oResponse = response.data[0];
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
          // console.log(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function GetCampaignFilterList() {
    axiosAuth
      .get(AppContext.APIURL + "api/PTCampaign/PTCampaignGetCompleteGridData")
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          l_oResponse = FilterJsonExactlyMatching(
            l_oResponse,
            "IsDeleted",
            false,
          );

          let selectedIds = "";

          for (let index = 0; index < l_oResponse.length; index++) {
            l_oResponse[index].PID = l_oResponse[index].PTCampaignID;
            l_oResponse[index].Name = l_oResponse[index].CampaignCode;
            selectedIds += l_oResponse[index].PTCampaignID + ",";
          }

          if (selectedIds != "") {
            selectedIds = selectedIds.replace(/,$/, "");
          }
          setselectedPIDs(selectedIds);
          setCampaignFilterList(l_oResponse);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function SetTotal() {
    var TotalVisits = 0;
    var StartedQuote = 0;
    var CompletedQuote = 0;
    var TotalDiscount = 0;
    var TotalRevenue = 0;
    for (var i = 0; i < thisGridListData.length; i++) {
      TotalVisits += 1;
      if (thisGridListData[i].Status > 6) {
        StartedQuote += 1;
      } else if (thisGridListData[i].Status == 5) {
        CompletedQuote += 1;
        TotalDiscount += thisGridListData[i].DiscountAmount;
        TotalRevenue += thisGridListData[i].Revenue;
      }
    }
    let thistotal = {} as any;
    thistotal.TotalVisits = TotalVisits;
    thistotal.StartedQuote = StartedQuote;
    thistotal.CompletedQuote = CompletedQuote;
    thistotal.TotalDiscount = TotalDiscount?.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    thistotal.TotalRevenue = TotalRevenue?.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    setTotals(thistotal);
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MNVMoverName")) {
        (
          document.getElementById(
            "imgSort" + "MNVMoverName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "DTDPerHourRateName")) {
        (
          document.getElementById(
            "imgSort" + "DTDPerHourRateName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "PTDPerHourRateName")) {
        (
          document.getElementById(
            "imgSort" + "PTDPerHourRateName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1],
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  function updateSelectedPIDForParent(type: any, value: any, name: any) {
    if (type == 1) {
      FilterObjectObject.CampaignCode = value;
      setFilterObjectObject((prevState: any) => ({
        ...prevState,
        CampaignCode: value,
      }));
    }
  }

  useEffect(() => {
    if (thisGridListData) SetTotal();
  }, [thisGridListData]);

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      <>
        <div className="grid-d fr-6 flex-gap10">
          <div className="field-input grid-d  flex-gap3">
            <span className="font-12 text-left label-color">Start Date</span>
            <input
              type="Date"
              className="input-field w-100"
              value={moment(FilterObjectObject.StartDate).format("YYYY-MM-DD")}
              onChange={(e) => {
                FilterObjectObject.StartDate = moment(e.target.value).format(
                  "YYYY-MM-DD",
                );
                setFilterObjectObject((prevState: any) => ({
                  ...prevState,
                  StartDate: moment(e.target.value).format("YYYY-MM-DD"),
                }));
              }}
            />
          </div>
          <div className="field-input grid-d  flex-gap3">
            <span className="font-12 text-left label-color">End Date</span>
            <input
              type="Date"
              className="input-field w-100"
              value={moment(FilterObjectObject.EndDate).format("YYYY-MM-DD")}
              onChange={(e) => {
                FilterObjectObject.EndDate = moment(e.target.value).format(
                  "YYYY-MM-DD",
                );
                setFilterObjectObject((prevState: any) => ({
                  ...prevState,
                  EndDate: moment(e.target.value).format("YYYY-MM-DD"),
                }));
              }}
            />
          </div>

          <div className="field-input grid-d flex-gap3 multi-new">
            <span className="font-12 text-left label-color">Campaign Code</span>

            <MultiSelectionDropdown
              listData={CampaignFilterList}
              selectAllName={"Select Campaign Code"}
              selectFewName={"Campaign Code"}
              updateSelectedPIDForParent={updateSelectedPIDForParent}
              type={1}
              selectedPID={selectedPIDs}
            ></MultiSelectionDropdown>
          </div>
          <div className="field-input grid-d  flex-gap3">
            <span className="font-12 text-left label-color">Discount Code</span>
            <input
              type="text"
              className="input-field w-100"
              value={FilterObjectObject.DiscountCode}
              onChange={(e) => {
                FilterObjectObject.DiscountCode = e.target.value;
                setFilterObjectObject((prevState: any) => ({
                  ...prevState,
                  DiscountCode: e.target.value,
                }));
              }}
            />
          </div>
          <div className="field-input grid-d  flex-gap3">
            <span className="font-12 text-left label-color">IP Address</span>
            <input
              type="text"
              className="input-field w-100"
              value={FilterObjectObject.IPAddress}
              onChange={(e) => {
                FilterObjectObject.IPAddress = e.target.value;
                setFilterObjectObject((prevState: any) => ({
                  ...prevState,
                  IPAddress: e.target.value,
                }));
              }}
            />
          </div>
          <div className="field-input grid-d  flex-gap3">
            <span className="font-12 text-left label-color">Status</span>
            <select
              value={FilterObjectObject.Status}
              onChange={(e) => {
                FilterObjectObject.Status = e.target.value;
                setFilterObjectObject((prevState: any) => ({
                  ...prevState,
                  Status: e.target.value,
                }));
              }}
              className="input-field w-100"
            >
              <option value="-1">All</option>
              <option value="1">Visit</option>
              <option value="2">Quote Started</option>
              <option value="3">Quote Linked</option>
              <option value="4">Quote Payment Started</option>
              <option value="5">Quote And Payment Done</option>
            </select>
          </div>
        </div>
        <div className="flex-daj btn-start flex-gap10 mt-10">
          <a className="btn-primary flex-daj" onClick={() => LoadDataMonth(0)}>
            Last Month
          </a>
          <a className="btn-primary flex-daj" onClick={() => LoadDataMonth(1)}>
            This Month
          </a>
          <a
            className="btn-primary flex-daj"
            onClick={() => LoadCampaignData()}
          >
            Apply Filter
          </a>
          <a className="btn-primary flex-daj" onClick={() => ClearFilter(0)}>
            Clear Filter
          </a>
        </div>
        <div className="grid-d fr-5 flex-gap10 mt-20">
          <div className="data-boxes">
            <span className="data-txt">Total</span>
            <span>{Totals.TotalVisits}</span>
          </div>
          <div className="data-boxes">
            <span className="data-txt">Started But Not Completed</span>
            <span>{Totals.StartedQuote}</span>
          </div>
          <div className="data-boxes">
            <span className="data-txt">Completed Quote</span>
            <span>{Totals.CompletedQuote}</span>
          </div>
          <div className="data-boxes">
            <span className="data-txt">Total Discount</span>
            <span>£{Totals.TotalDiscount}</span>
          </div>
          <div className="data-boxes">
            <span className="data-txt">Total Revenue</span>
            <span>£{Totals.TotalRevenue}</span>
          </div>
        </div>
        <div className="flex-da justify-end mt-10 mb-10 flex-gap10">
          <div className="flex-daj flex-gap10">
            <a
              className="link-btn btn-link-m"
              onClick={() => ClearAllFilters()}
            >
              Clear All Filters
            </a>
            <a
              className="btn-primary flex-daj btn-grid"
              title="Export"
              onClick={() =>
                DownloadClientsDataInExcel("tblcampaigndata", "campaign data")
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>{" "}
        </div>
        <div className="flow-auto-lg">
          <table className="reuse-table" id="tblcampaigndata">
            <thead>
              <tr>
                <th>
                  <div className="flex-daj flex-gap20">
                    <div className="flex-da flex-gap5">
                      Dated
                      <a
                        onClick={(e) =>
                          ShowColumnFilterList(e, "CreationTimestamp")
                        }
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() =>
                          LoadWithSelectedSort("CreationTimestamp")
                        }
                        title={"Sort By Dated"}
                      >
                        <span id={"imgSort" + "CreationTimestamp"}></span>
                      </a>
                    </div>
                  </div>
                </th>
                <th>
                  <div className="flex-daj flex-gap20">
                    <div className="flex-da flex-gap5">
                      IP Address
                      <a
                        onClick={(e) => ShowColumnFilterList(e, "IPAddress")}
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() => LoadWithSelectedSort("IPAddress")}
                        title={"Sort By IPAddress"}
                      >
                        <span id={"imgSort" + "IPAddress"}></span>
                      </a>
                    </div>
                  </div>
                </th>
                <th>
                  <div className="flex-daj flex-gap20">
                    <div className="flex-da flex-gap5">
                    Email Address
                      <a
                        onClick={(e) => ShowColumnFilterList(e, "EmailAddress")}
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() => LoadWithSelectedSort("EmailAddress")}
                        title={"Sort By Email Address"}
                      >
                        <span id={"imgSort" + "EmailAddress"}></span>
                      </a>
                    </div>
                  </div>
                </th>
                <th>
                  <div className="flex-daj flex-gap20">
                    <div className="flex-da flex-gap5">
                      Discount Code
                      <a
                        onClick={(e) => ShowColumnFilterList(e, "DiscountCode")}
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() => LoadWithSelectedSort("DiscountCode")}
                        title={"Sort By Discount Code"}
                      >
                        <span id={"imgSort" + "DiscountCode"}></span>
                      </a>
                    </div>
                  </div>
                </th>
                <th>Entry Campaign Code</th>
                <th>Exit Campaign Code</th>
                <th>Discount Amount (£)</th>
                <th>Revenue (£)</th>
                <th>Status Text</th>
                <th>Job ID</th>
              </tr>
            </thead>
            <tbody>
              {thisGridListData &&
                thisGridListData.map((item: any, index: any) => (
                  <React.Fragment key={index}>
                    {!item.IsExcluded && (
                      <tr>
                        <td>{formateDate(item.CreationTimestamp)}</td>
                        <td>{item.IPAddress}</td>
                        <td>{item.EmailAddress}</td>
                        <td>{item.DiscountCode}</td>
                        <td>{item.CampaignCode}</td>
                        <td>{item.ExitCampaignCode}</td>
                        <td className="text-right">
                          {item.DiscountAmount?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td className="text-right">
                          {item.Revenue?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td>{item.StatusText}</td>
                        <td>
                          {item.ObjectID > 0 && (
                            <a
                              href={
                                item?.ObjectID
                                  ? `/quote_detail/${item.ObjectID}`
                                  : "#"
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              #{250000 + item.ObjectID}
                            </a>
                          )}
                          {item.ObjectID > 0 && item.InternalLink != "" && (
                            <span>, </span>
                          )}
                          {item.ObjectID <= 0 && item.InternalLink == "" && (
                            <span>-</span>
                          )}
                          {item.InternalLink != "" && (
                            <a
                              href={
                                item?.InternalLink
                                  ? `/quote_detail/${item.InternalLink - 250000}`
                                  : "#"
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              #{item.InternalLink}
                            </a>
                          )}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
            </tbody>
          </table>
        </div>
      </>
    </div>
  );
}

export default CampaignData;
